const PLAYER_STATUSES = {
  PLAYING: 0,
  PAUSED: 1,
  WAITING: -1
};
const CALENDAR_VIEW_MODES = {
  MONTH: 0,
  WEEK: 1,
  DAY: 2
};
const PRODUCT_PAGE_VIEW_MODES = {
  NOVITA: 0,
  POPOLARI: 1,
  OFFERTE: 2,
  TUTTI: 3,
  MIEI: 4
};
const MODEL_TYPES = {
  CALENDAR_EVENT: 'calendarEvent',
  MARKET_PRODUCT: 'marketProduct',
  RADIO_STATIONS: 'radioStation',
  RDS_USER: 'rdsUser',
  DISH: 'dish',
  NOTIFICATION: 'notification',
  DRIVER_SHIFT: 'driverShift'
};
export default {
  playerStatuses: PLAYER_STATUSES,
  calendarViewModes: CALENDAR_VIEW_MODES,
  productPageViewModes: PRODUCT_PAGE_VIEW_MODES,
  modelTypes: MODEL_TYPES
};
